import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, Field } from 'redux-form';

import { init } from './cameraActions';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndSelectForm from '../common/form/labelAndSelectForm';
import Button from '../common/form/button';

class CameraForm extends Component {
  renderControladorOptions() {
    const controladores = (this.props.controladores || []).filter(item => Number(item.anel) === 1);

    return controladores.map(ctrl => (
      <option key={ctrl.id} value={ctrl.id}>
        {`${ctrl.grupo_fisico_id} - Ctrl ${String(ctrl.numero_controlador).padStart(2, '0')} - ${ctrl.endereco || 'Sem endereço'}`}
      </option>
    ));
  }

  render() {
    const { handleSubmit, readOnly } = this.props;

    return (
      <form onSubmit={handleSubmit} autoComplete="off">
        <div className="box-body">
          {readOnly && (
            <Field name="id" component={LabelAndInput} readOnly label="Código" cols="12 3" placeholder="Código" />
          )}

          <Field
            name="descricao"
            component={LabelAndInput}
            maxLength={120}
            label="Descrição"
            cols="12 6"
            placeholder="Ex: Câmera Detecção Norte"
          />

          <Field name="tipo" component={LabelAndSelectForm} label="Tipo" cols="12 3">
            <option value="deteccao">Detecção</option>
            <option value="monitoramento">Monitoramento</option>
          </Field>

          <Field name="ativo" component={LabelAndSelectForm} label="Ativo" cols="12 3">
            <option value={1}>Sim</option>
            <option value={0}>Não</option>
          </Field>

          <Field name="controlador_id" component={LabelAndSelectForm} label="Controlador" cols="12 6">
            <option value="">Selecione...</option>
            {this.renderControladorOptions()}
          </Field>

          <Field
            name="endereco"
            component={LabelAndInput}
            maxLength={255}
            label="Endereço IP / URL"
            cols="12 6"
            placeholder="Ex: 192.168.1.244 ou http://192.168.1.244/login.jsp"
          />

          <Field
            name="ordem"
            component={LabelAndInput}
            type="number"
            label="Ordem"
            cols="12 3"
            placeholder="0"
          />
        </div>

        <div className="box-footer">
          <Button type="submit" className={this.props.submitClass} icon="check" label={this.props.submitLabel} />
          <Button type="button" className="default" icon="close" label="Cancelar" onClick={this.props.init} />
        </div>
      </form>
    );
  }
}

CameraForm = reduxForm({ form: 'cameraForm', destroyOnUnmount: false })(CameraForm);

const mapStateToProps = state => ({
  controladores: state.cameraCad.controladores,
});

const mapDispatchToProps = dispatch => bindActionCreators({ init }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CameraForm);
